import { Navigate, createBrowserRouter } from 'react-router-dom';
import { wrapCreateBrowserRouter } from '@sentry/react';

import ErrorFallback from 'components/fallback/ErrorFallback';
import { MainLayout } from 'components/layout/MainLayout';
import { SidebarLayout } from 'components/layout/SidebarLayout';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { alertsRoutes } from 'pages/Alerts/Alerts.routes';
import { assetsOverviewRoutes, assetsRoutes } from 'pages/Assets/Assets.routes';
import {
  blueprintsOverviewRoutes,
  blueprintsRoutes,
  editBlueprintRoute,
  newBlueprintRoute,
} from 'pages/Blueprints/Blueprints.routes';
import { managementRoutes } from 'pages/Management/Management.routes';
import { newProjectRoute, projectsOverviewRoutes, projectsRoutes } from 'pages/Projects/Projects.routes';
import { sharedBlueprintRoutes } from 'pages/Shared/Shared.routes';
import { USER_PREFERENCES } from 'utils/constants';
import { DevelopmentOnly } from 'components/auth/DevelopmentOnly';
import {Component as TestDataGenerator} from 'pages/TestDataGenerator';

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

const DefaultRedirect = () => {
  const [landingPage] = useLocalStorage(
    USER_PREFERENCES.LANDING_PAGE.LOCAL_STORAGE_KEY,
    USER_PREFERENCES.LANDING_PAGE.DEFAULT
  );

  return <Navigate to={landingPage} replace />;
};

export const routes = [
  {
    path: '/login',
    lazy: () => import('./pages/Login'),
  },
  ...sharedBlueprintRoutes,
  {
    element: <MainLayout />,
    path: '/',
    errorElement: <ErrorFallback />,
    children: [
      {
        index: true,
        element: <DefaultRedirect />,
      },
      ...projectsOverviewRoutes,
      ...assetsOverviewRoutes,
      ...alertsRoutes,
      ...blueprintsOverviewRoutes,
      ...blueprintsRoutes,
      newProjectRoute,
      newBlueprintRoute,
      editBlueprintRoute,
      {
        path: 'glossary',
        lazy: () => import('./pages/Glossary'),
      },
      {
        path: 'preferences',
        lazy: () => import('./pages/Preferences'),
      },
      {
        path: '',
        element: <SidebarLayout />,
        children: [...projectsRoutes, ...managementRoutes, ...assetsRoutes],
      },
      {
        path: '/404',
        lazy: () => import('./pages/NotFound'),
      },
      {
        path: '/test-data',
        element: (
          <DevelopmentOnly>
            <TestDataGenerator />
          </DevelopmentOnly>
        ),
      },
      {
        path: '*',
        element: <DefaultRedirect />,
      },
    ],
  },
];

export const browserRouter = sentryCreateBrowserRouter(routes);
